import { render } from "./SearchBar.vue?vue&type=template&id=07acdec9&scoped=true&ts=true"
import script from "./SearchBar.ts?vue&type=script&lang=ts&external"
export * from "./SearchBar.ts?vue&type=script&lang=ts&external"

import "./SearchBar.scss?vue&type=style&index=0&id=07acdec9&lang=scss&scoped=true&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07acdec9"]])

export default __exports__